import { Component, Input, OnInit } from '@angular/core';
import { FaDirectiveEnum } from '../../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../../bary-icon/bary-icon.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'jhi-cart-value',
  standalone: true,
  templateUrl: './cart-value.component.html',
  styleUrls: ['./cart-value.component.scss'],
  imports: [BaryIconComponent, NgIf],
})
export class CartValueComponent implements OnInit {
  @Input() label!: string;
  @Input() color = 'text-gray';
  @Input() currency = 'EUR';
  @Input() suffix?: string;
  @Input() options!: {
    withCurrency?: boolean;
    italic?: boolean;
    icon?: string;
    iconColor?: string;
    reverse?: boolean;
  };
  @Input() value!: any;

  protected readonly FAS = FaDirectiveEnum.FAS;

  private _defaultOptions: { withCurrency?: boolean; italic?: boolean; icon?: string; iconColor?: string } = {
    withCurrency: true,
    italic: false,
  };

  public ngOnInit(): void {
    this.options = { ...this._defaultOptions, ...this.options };
  }
}
